export const COUPON_TYPES = {
    INTRODUCTION: 'introduction',
    REPEAT: 'repeat',
    BULK: 'bulk',
    CROSS: 'cross',
  } as const;
  
  export type CouponTypeValue = typeof COUPON_TYPES[keyof typeof COUPON_TYPES];
  
  export type CouponTypeInfo = {
    value: CouponTypeValue;
    label: string;
    description: string;
  };
  
  export const couponTypes: readonly CouponTypeInfo[] = [
    {
      value: COUPON_TYPES.INTRODUCTION,
      label: "紹介割引",
      description:
        "プロジェクトの実行者から紹介を受けた支援者が使用できる割引クーポンです。\n実行者は、プロジェクト開始前にメルマガなどを通じて、友人や知人にクーポンコードを知らせておきます。\nその後、プロジェクト開始後に支援者がクーポンコードを入力することで、割引が適用されます。",
    },
    {
      value: COUPON_TYPES.REPEAT,
      label: "リピート割引",
      description:
        "過去に同じ実行者のプロジェクトを支援した支援者が利用できる割引クーポンです。\nこのクーポンを使って再度支援を促すことで、継続的な支援を獲得できます。",
    },
    {
      value: COUPON_TYPES.BULK,
      label: "まとめ買い割引",
      description:
        "一度に複数のリターン品をまとめて支援する際に使用できる割引クーポンです。\nこれはいわゆるボリュームディスカウントであり、多くのリターン品を支援する支援者を優遇できます。",
    },
    {
      value: COUPON_TYPES.CROSS,
      label: "応援ハシゴ割引",
      description:
        "過去に別の実行者のプロジェクトを支援した支援者が使用できる割引クーポンです。\nたとえば、プロのサッカーチームを支援したことがあるファンが、このクーポンをきっかけに、新たなプロジェクトにも関心を持ち、支援を広げてくれる可能性があります。",
    },
  ];
  
  export const getCouponLabel = (typeValue: string): string => {
    return couponTypes.find((coupon) => coupon.value === typeValue)?.label || typeValue;
  };
